import _ from "lodash";
import { GetServerSidePropsContext } from "next";
import { API, Http } from "services/http/http";
import { paramsObjectToQueryString } from "utils/generic-utils";

export const fetchCourses = (id: string, payload: Record<string, any>) =>
   API({
      method: "GET",
      url: `/study-abroad/course/partner/${id}${paramsObjectToQueryString(payload)}`,
   });

export const fetchAllCourses = (payload: Record<string, any>) =>
   API({
      method: "GET",
      url: `/study-abroad/course/${paramsObjectToQueryString(payload)}`,
   });

export const fetchCourse = (id, ctx?: GetServerSidePropsContext) =>
   API(
      {
         method: "GET",
         url: `/study-abroad/course/${id}`,
      },
      ctx
   );

export const searchStudyAbroadCourse = (id: string, val: string) =>
   Http.get(`/study-abroad/course/partner/${id}?name=${val}`);

export const createStudyAbroadPartner = (payload: any) =>
   Http.post("/study-abroad/partner", payload);
export const editStudyAbroadPartner = (id: string, payload: any) =>
   Http.put(`/study-abroad/partner/${id}`, payload);
export const deleteStudyAbroadPartner = (id: any) => Http.delete(`/study-abroad/partner/${id}`);
export const searchStudyAbroadPartner = (val: string) =>
   Http.get(`/study-abroad/partner?name=${val}`);

export const fetchStudyAbroadPartners = (payload: Record<string, any>) =>
   API({
      method: "GET",
      url: `/study-abroad/partner${paramsObjectToQueryString(payload)}`,
   });

export const getStudyAbroadPartner = (id, ctx?: GetServerSidePropsContext) =>
   API(
      {
         method: "GET",
         url: `/study-abroad/partner/${id}`,
      },
      ctx
   );

export const createScholarship = (payload: any) => Http.post("/scholarship", payload);
export const editScholarship = (id: string, payload: any) =>
   Http.put(`/scholarship/${id}`, payload);
export const searchStudyAbroadScholarship = (val: string) =>
   Http.get(`/scholarship?country=${val}`);
export const fetchScholarships = (payload: Record<string, any>) =>
   API({
      method: "GET",
      url: `/scholarship${paramsObjectToQueryString(payload)}`,
   });
export const deleteScholarship = (id: any) => Http.delete(`/scholarship/${id}`);
export const publishScholarship = (id: any, status: any) =>
   Http.patch(`/scholarship/${id}/${status}`);
export const fetchSingleScholarship = (id, ctx?: GetServerSidePropsContext) =>
   API(
      {
         method: "GET",
         url: `/scholarship/${id}`,
      },
      ctx
   );

//applications
export const fetchStudyAbroadApplications = (payload: Record<string, any>) =>
   API({
      method: "GET",
      url: `/study-abroad/application${paramsObjectToQueryString(payload)}`,
   });

export const fetchStudyAbroadApplication = (id, ctx?: GetServerSidePropsContext) =>
   API(
      {
         method: "GET",
         url: `/study-abroad/application/${id}`,
      },
      ctx
   );

export const searchStudyAbroadApplication = (val: string) =>
   Http.get(`/study-abroad/application?name=${val}`);

export const fetchStudyAbroadEnquiries = (payload: Record<string, any>) =>
   API({
      method: "GET",
      url: `/study-abroad${paramsObjectToQueryString(payload)}`,
   });

export const getStudyAbroadEnquiry = (id, ctx?: GetServerSidePropsContext) =>
   API(
      {
         method: "GET",
         url: `/study-abroad/${id}`,
      },
      ctx
   );
